// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/class-c-entry-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/class-c-entry-procedures/class-c-entry-procedures.js';

mount([g0]);
